import { getRTL } from '@uifabric/utilities';

export const enum PileDirection {
    Straight = 1,
    Left,
    Right,
}

const PILE_DISPLACEMENT: number = 7;
const SINGLE_DIGIT_WIDTH_FOR_ONE: number = 9;
const SINGLE_DIGIT_WIDTH_FOR_NON_ONE: number = 8.25;
const MULTI_DIGIT_OFFSET: number = 4.5;
const MULTI_DIGIT_FACTOR_FOR_ADDITIONAL_ONE: number = 0.75;
const BUTTON_WIDTH: number = 24;

/**
 * Returns the calendar icon svg text transform property
 * @param todayDate today's date to be displayed in the calendar icon(between 1 and 31). It is not the timestamp
 * @param pileDirection Whether it is right or left facing
 */
const getCalendarIconTransformSvg = (
    todayDate: number,
    pileDirection: PileDirection = PileDirection.Straight
) => {
    let transformSvgXValue: number;
    if (todayDate < 10) {
        transformSvgXValue =
            todayDate === 1 ? SINGLE_DIGIT_WIDTH_FOR_ONE : SINGLE_DIGIT_WIDTH_FOR_NON_ONE;
    } else {
        transformSvgXValue = MULTI_DIGIT_OFFSET;
        let oneCount: number = 0;
        // For 2 digit we need to set the margins according to the no of 1 present in the todayDate.
        // for each 1 found in the date, we need to shift to the right by 0.75 translate X value.
        todayDate
            .toString()
            .split('')
            .forEach(digit => {
                if (digit === '1') {
                    oneCount++;
                }
            });
        transformSvgXValue += MULTI_DIGIT_FACTOR_FOR_ADDITIONAL_ONE * oneCount;
    }

    const isRTL: boolean = getRTL();
    const pileCorrection: number = pileDirection === PileDirection.Right ? PILE_DISPLACEMENT : 0;

    if (isRTL) {
        /**
         * transform in the case of rtl takes the right side of the container as the 0 reference instead of left, and hence the translation is total width - calculation
         * |<------------------------total Width ----------------------->|
         * |------------------------------------<number>-----------------|
         * |<---Needed transformSvgValue>------>|------------------------|
         * reference for ltr                                            reference for rtl
         */
        transformSvgXValue =
            BUTTON_WIDTH + pileCorrection /** the width of the svg button */ - transformSvgXValue;
    } else {
        transformSvgXValue += pileCorrection;
    }

    return 'translate(' + transformSvgXValue + ', 16)';
};

export default getCalendarIconTransformSvg;
